import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import { LimitValue } from '../../../utils/LimitValue';

const corPrimaria = "#0b243d";

const textoMeses = (meses) => (Number(meses) === 1 ? "1 mês" : `${meses} meses`);

// Janela compartilhada por "Adicionar" e "Editar" desconto: os campos são os mesmos,
// cada componente cuida da busca e do envio.
export default function FormularioDesconto({
    aberto, titulo, descricao, textoBotao, salvando, onClose, onSubmit,
    discountCode, setDiscountCode, valorDesconto, setValorDesconto, duracaoMeses, setDuracaoMeses,
}) {
    const previaCompleta = discountCode && valorDesconto !== '' && duracaoMeses !== '';

    return (
        <Dialog
            open={aberto}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            // Enter em qualquer campo envia o formulário
            slotProps={{ paper: { component: "form", onSubmit } }}
        >
            <DialogTitle sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 2, pb: 1 }}>
                <Box>
                    <Typography sx={{ fontSize: 18, fontWeight: 600 }}>{titulo}</Typography>
                    <Typography variant="body2" color="text.secondary">{descricao}</Typography>
                </Box>
                <IconButton size="small" aria-label="Fechar" onClick={onClose}>
                    <CloseIcon fontSize="small" />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <TextField
                    autoFocus
                    required
                    label="Código do desconto"
                    placeholder='Ex.: BEMVINDO10'
                    type="text"
                    fullWidth
                    value={discountCode || ''}
                    onChange={(e) => setDiscountCode(e.target.value)}
                    variant="outlined"
                    size='small'
                    helperText="É o código que o cliente digita ao assinar."
                    slotProps={{ htmlInput: { style: { fontFamily: "monospace", letterSpacing: 0.5 } } }}
                />
                <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "1fr 1fr" }}>
                    <TextField
                        required
                        label="Desconto"
                        placeholder='0'
                        type="text"
                        fullWidth
                        value={valorDesconto}
                        onChange={(e) => setValorDesconto(LimitValue(e.target.value))}
                        variant="outlined"
                        size='small'
                        helperText="De 0 a 100"
                        slotProps={{ input: { endAdornment: <InputAdornment position="end">%</InputAdornment> } }}
                    />
                    <TextField
                        required
                        label="Duração"
                        placeholder='0'
                        type="text"
                        fullWidth
                        value={duracaoMeses}
                        onChange={(e) => setDuracaoMeses(LimitValue(e.target.value))}
                        variant="outlined"
                        size='small'
                        helperText="Em meses"
                        slotProps={{ input: { endAdornment: <InputAdornment position="end">meses</InputAdornment> } }}
                    />
                </Box>

                {/* Prévia de como o desconto vai funcionar */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, p: 1.5, borderRadius: 1.5, backgroundColor: "#f5f7fa" }}>
                    <LocalOfferOutlinedIcon sx={{ color: previaCompleta ? corPrimaria : "text.disabled" }} />
                    <Typography variant="body2" color={previaCompleta ? "text.primary" : "text.secondary"}>
                        {previaCompleta ? (
                            <>O código <strong style={{ fontFamily: "monospace" }}>{discountCode}</strong> dá <strong>{valorDesconto}%</strong> de desconto por <strong>{textoMeses(duracaoMeses)}</strong>.</>
                        ) : (
                            "Preencha os campos para ver a prévia do desconto."
                        )}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 1.5 }}>
                <Button onClick={onClose} size='small' sx={{ textTransform: "none" }} disabled={salvando}>Cancelar</Button>
                <Button
                    type="submit"
                    variant='contained'
                    size='small'
                    loading={salvando}
                    sx={{ backgroundColor: corPrimaria, textTransform: "none", "&:hover": { backgroundColor: "#153d66" } }}
                >
                    {textoBotao}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
